import { render } from "./BasicSetupForm.vue?vue&type=template&id=010dbcfe"
import script from "./BasicSetupForm.vue?vue&type=script&lang=js"
export * from "./BasicSetupForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__